<template>
  <div class="skeleton-resource-card">
    <ion-card v-for="i in 10" :key="i" color="light">
      <ion-card-header>
        <ion-card-title class="h-f-b">
          <ion-skeleton-text animated></ion-skeleton-text>
        </ion-card-title>
        <ion-card-subtitle class="h-f-m">
          <ion-skeleton-text animated style="width:60%"></ion-skeleton-text>
        </ion-card-subtitle>
      </ion-card-header>

      <ion-card-content>
        <p>
          <ion-skeleton-text animated></ion-skeleton-text>
          <ion-skeleton-text animated style="width:60%"></ion-skeleton-text>
        </p>
      </ion-card-content>

      <ion-card-footer>
        <div class="ion-padding">
          <span class="h-f-m">Tagged:</span>
          <ion-chip color="tertiary" outline="true">
            <ion-label>
              <ion-skeleton-text animated></ion-skeleton-text>
            </ion-label>
          </ion-chip>
        </div>
      </ion-card-footer>
    </ion-card>
  </div>
</template>

<script>
export default {
  name: "skeleton-resouce-card"
};
</script>